export default {
  getFeedback: state => state.feedback,
}
